var map = {
	"./20210427-reboot-game.md": 3989,
	"./20210430-birdie-challenge-update.md": 8960,
	"./20210730-birdie-challenge-update.md": 4765,
	"./20211111-first-eagle.md": 9521,
	"./20220930-fall-golf.md": 3029,
	"./20221010-top-5-alister-mackenzie.md": 2433,
	"./20221101-cold-weather-tips.md": 5648,
	"./20230201-january-players-of-the-month.md": 8610,
	"./20230227-netflix-full-swing-season-1-review.md": 1405,
	"./20230301-february-players-of-the-month.md": 3359,
	"./20230306-can-pga-tour-and-liv-golf-coexist.md": 8136,
	"./20230313-is-the-players-still-the-fifth-major.md": 5931,
	"./20230320-bittersweet-spring.md": 8086,
	"./20230401-augusta-national-to-open-for-public-tee-times.md": 7032,
	"./20230403-march-players-of-the-month.md": 8151,
	"./20230501-april-players-of-the-month.md": 2387
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(function() {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}

		var id = map[req];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 7948;
module.exports = webpackAsyncContext;